var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWcpeLogoColor01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1360.63 397.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-10,.cls-9{fill:#00488e;}.cls-9{stroke:#00488e;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 493.4,
    y1: 132.27,
    x2: 710.8,
    y2: 257.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0e4473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#235880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#386c8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3f7392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#396d8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#275c83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0e4473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002a54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002553"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 605.66,
    y1: 55.76,
    x2: 696.97,
    y2: 213.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 716.52,
    y1: 54.61,
    x2: 716.52,
    y2: 164.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 789.29,
    y1: 87.4,
    x2: 760.08,
    y2: 137.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 827.52,
    y1: 114.35,
    x2: 795.02,
    y2: 146.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 852.4,
    y1: 141.83,
    x2: 819.38,
    y2: 160.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 868.58,
    y1: 165.42,
    x2: 835.65,
    y2: 184.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 883.2,
    y1: 196.65,
    x2: 843.52,
    y2: 196.65,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M723.85,203.8l-221.34-.12c-34.69.46-39.27-11.42-35.62-22.55,5.13-15.65,19-33.32,29.57-46.39,16.28-20.1,32.56-21.45,60.41-11.56l171.36,67.37C748,199.65,751.48,203.24,723.85,203.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M565.74,105.88C543.54,95.16,549.36,88,558.56,83c12.87-7,32-15.67,49.46-20.89,7.44-2.21,15.19-3.41,22.73-1,11.38,3.62,19.41,12.12,27.57,20.32l17.11,17.22,43.84,44.12C729.53,153,737,160.12,747.21,170.45c11.12,11.23,8.87,14.38-8,8.09-6-2.24-9.08-3.61-15.07-5.88-17.22-6.51-34.27-13.49-51.27-20.54q-28-11.6-55.82-23.61c-14-6-27.9-12-41.76-18.25C572.12,108.83,568.9,107.41,565.74,105.88Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M751.62,150.61,670.77,68.07c-8-8.87-13.54-12.16-4.49-13.14,8.45-.91,27.48.25,40.31,2,18.83,2.61,18.53,3.93,33.46,31.56l21.68,45C782.61,179.85,765.24,164.84,751.62,150.61Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M781.83,141.17,760.6,89.74c-.75-1.76-9.41-22.31.11-17.85,8.65,4,14.12,7.18,20.78,11,9,5.17,10,13.19,10.33,17.07l1.35,41.55C792.83,155.66,792.16,164.31,781.83,141.17Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M825.81,123.74l-8,22.34c-8,21.9-10.1,20-10.33-2.47l1.24-35c.33-5.17.08-9.93,6.17-5.62a54.89,54.89,0,0,1,9.66,8.54C828.64,115.88,828.51,115.88,825.81,123.74Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M834,165.51c-9.54,8-11,8.79-6-3.48,11.79-28.41,14.75-31.24,17.41-28.86,2.87,2.58,5.87,5.32,7.09,10.05C853.43,146.58,838.38,161.86,834,165.51Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M865.9,161.58c2,2,3.75,6,4.16,6.85,2.47,4.83-1.91,4.94-24.48,16.06-12.08,5.95-9.1,1.46-4.49-3.48,4.25-4.57,11-10.79,15.27-14.94C864.11,158.55,864.78,160.46,865.9,161.58Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M879.27,204.48l-29.65-.56c-9.32,0-6.62-2.25-.79-4.61L873,190.67c7.18-2.47,7.26-3,8.87,2a23.79,23.79,0,0,1,1.35,7.52C883.31,203.55,882.11,204.37,879.27,204.48Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M111.51,298.75,97.93,348.46H89.61L72.06,286.83h8.5l13.67,51.38,14.14-51.38h6.38l14.14,51.38,13.58-51.38H151l-17.55,61.63H125.1Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M219.91,286.83H260.3v6.83H227.58v19.87h32.07v6.84H227.58v21.25H260.3v6.84H219.91Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M333.67,334a26.06,26.06,0,0,0,19.41,8.78c11,0,14.5-5.91,14.5-10.62,0-7.4-7.48-9.43-15.61-11.65-9.89-2.58-20.89-5.36-20.89-17.46,0-10.17,9.06-17.1,21.16-17.1,9.43,0,16.73,3.14,21.91,8.6l-4.63,5.63c-4.62-5.08-11.09-7.39-17.83-7.39-7.39,0-12.66,4-12.66,9.8,0,6.19,7.11,8,15,10.16,10.07,2.68,21.53,5.82,21.53,18.76,0,9-6.1,18.11-22.73,18.11-10.72,0-18.58-4.06-23.66-9.79Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M462,293.66h-19.5v-6.83h46.76v6.83H469.7v54.8H462Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M559.8,286.83h40.38v6.83H567.47v19.87h32.06v6.84H567.47v21.25h32.71v6.84H559.8Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M692.68,324H680.39v24.49h-7.67V286.83h24.77c11.27,0,19.31,7.2,19.31,18.57,0,11.09-7.58,17.19-16,17.93l16.64,25.13h-9.06Zm3.88-30.31H680.39v23.57h16.17c7.3,0,12.29-4.9,12.29-11.83S703.86,293.66,696.56,293.66Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M796.92,298.75v49.71h-7.67V286.83h7.86l35.48,48.7v-48.7h7.67v61.63h-7.39Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M996.71,317.69c0-18.94,14-31.88,31.42-31.88a27.73,27.73,0,0,1,23.66,12.2l-6.47,3.6a20.93,20.93,0,0,0-17.19-9c-13.21,0-23.47,10.35-23.47,25s10.26,25,23.47,25a20.68,20.68,0,0,0,17.19-9l6.56,3.6c-5.17,7-12.57,12.2-23.75,12.2C1010.67,349.57,996.71,336.63,996.71,317.69Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1122,286.83h24.77c12.38,0,19.31,8.5,19.31,18.57S1159,324,1146.79,324h-17.1v24.49H1122Zm23.84,6.83h-16.17v23.48h16.17c7.3,0,12.29-4.81,12.29-11.74S1153.16,293.66,1145.86,293.66Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1236.61,286.83H1277v6.83h-32.71v19.87h32.07v6.84h-32.07v21.25H1277v6.84h-40.38Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M876.38,289.61h-7.51V287h18v2.64h-7.55v21.1h-3Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M911.08,291,903,310.71h-1.21l-8-19.75v19.75h-3V287H895l7.37,18.08L909.8,287H914v23.74h-2.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcpeLogoColor01);
export default __webpack_public_path__ + "static/media/WCPE_logo_color-01.f8e1a35be839f71265012fa5ca02d752.svg";
export { ForwardRef as ReactComponent };